import {
    createTable,
    ITableRow,
    ITableProperties,
    Table,
} from '@vfde-brix/ws10/table';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { renderTextLink } from '@vfde-brix/ws10/styles';
import { AbstractedAttribute } from '@vfde-sails/glados-v2';

/**
 * Mount the simple table
 */
export const mountTableForTechnicalDetails = (
    container: HTMLElement,
    caption: string,
    attributes: AbstractedAttribute[],
): Table => {
    const listRow = [];
    const { key: ecoKey } = window[ADDITIONAL_PAGE_OPTIONS].ecoLabel;
    const specialValuesMap = new Map<string, CallableFunction>();

    specialValuesMap.set(ecoKey, getEcoLabel);

    for (const attribute of attributes) {
        const { label, value } = attribute;
        const specialValueFunction = specialValuesMap.get(label);
        const item: ITableRow = specialValueFunction ? specialValueFunction(label, value) : {
            stdLabel: label,
            stdText: value,
        };

        listRow.push(item);
    }

    const properties: ITableProperties = {
        stdCaption: caption,
        listRow,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createTable(container, properties);
};

/**
 * This function is a special case and only used for a few devices (e. g. Fairphone 5)
 * Glados delivers following attribute for it:
 * ```
 * {
 *  "uniqueIdentifier": "sustainability",
 *  "displayLabel": "Nachhaltigkeit",
 *  "sortOrder": 99,
 *  "values": [
 *    {
 *      "value": "Eco Rating 89/100",
 *      "sortOrder": 23
 *    }
 *  ]
 * }
 * ```
 * So in that case we render a link to more infos.
 */
const getEcoLabel = (label: string, value: string): ITableRow => {
    const { link, text } = window[ADDITIONAL_PAGE_OPTIONS].ecoLabel;

    const textLinkHtml = renderTextLink({
        stdContent: text,
        linkHref: link,
        optTarget: '_blank',
    });

    return {
        stdLabel: label,
        stdText: `${value} ${textLinkHtml}`,
    };
};
